/** Authenticated, top-level W2 plan-selection surface (outside `/e/:token`). */
export const SELECTION_ROUTE = '/select-plans';

/** Where an unauthenticated selection visitor is bounced so login returns here. */
export const SELECTION_LOGIN_REDIRECT = `/login?next=${SELECTION_ROUTE}`;
